var targetNode = document.getElementById(target);
var config = { attributes: true, childList: true, subtree: true };
var callback = function (mutationsList, observer) {
  for (var mutation of mutationsList) {
    checkQtys();
  }
  observer.disconnect();
};
var observer = new MutationObserver(callback);

observer.observe(targetNode, config, function () {
});

// ------- START AF30042021 - Fix for check cart products quantity in minicart -------

// Function to check if the price of the quantity selected in the cart does not exceed the maximum allowed for the product
function checkCartItems() {
  // Get all items in cart
  var cartItemsJS = $('.cart_item');

  // if there are items in cart...
  if (cartItemsJS.length > 0) {
    // for each item in cart get the attributes for quantity in cart, the item price, the max price expendable for that product and the button to add one more unit of the product
    cartItemsJS.each(function () {
      var cartItemJS_line_price = $(this).data('line_price');
      var cartItemJS_max_avaible = $(this).data('max_avaible');
      var cartItemJS_line_qty = $(this).data('line_qty');
      var cartItemJS_add_btn = $(this).find('[data-action="increase-quantity"]');

      // FUNCTION TO CHECK THE QUANTITY SELECTED BY USER
      function checkMaxQuantity() {
        cartItemJS_line_qty = cartItemJS_line_qty + 1;
        cartItemJS_add_btn.on('click', function (e) {
          if (cartItemJS_max_avaible < cartItemJS_line_price * cartItemJS_line_qty) {
            alert(window.languages.reachedMaxAvailable);
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        });
      }

      // check if the quantity if the user wants to add doesn't exceed the max price expendable for that product
      checkMaxQuantity();

    });
  }

}

// MUTATION OBSERVER FOR MINICART
// Set element to listen and events to listen
var targetNd = document.querySelector('.mini-cart');
var cfg = { attributes: true, childList: true, subtree: true };
var callback = function (mutationsList, newobserver) {
  for (var mutation of mutationsList) {
    checkCartItems();
  }
};
var newobserver = new MutationObserver(callback);
newobserver.observe(targetNd, cfg);

// ------- END AF30042021 - Fix for check cart products quantity in minicart -------

$(document).ready(function () {

  $('.mini-cart__quantity').on('change', function () {
    checkQtys();
  });

  $('.cart_action').on('click', function (e) {
    let amount = $('.product-form .quantity-selector__value').val();
    let more_av = $('.product-form [name="more_avaible"]').val();
    let line_pric = $('.product-form [name="lineprice"]').val();
    // ------- START AF30042021 - Fix for check cart products quantity for product page -------

    // In product page...

    // Get variant of selected product
    var checkedVariantId = $('.block-swatch__radio:checked').data('variant-id');
    var itemTotalQty = 0;

    // Get selected product price
    var current_var_price = document.querySelector('.product-form__current-price').innerText;
    current_var_price = current_var_price.replace('€', '').split(',')[0];

    // If there are items in cart
    if ($('.cart_item').length > 0) {
      $('.cart_item').each(function () {
        // Get the variant id of product in the cart
        var itemCartQty;
        var item = $(this);
        var itemVariantId = item.data('line_var_id');
        // if the cart item id is equal to the selected variant in page... 
        if (itemVariantId == checkedVariantId) {
          //... get the current quantity of the item in cart...
          itemCartQty = $(this).find('.quantity-selector__value').data('current-value');
          //... and add to the quantity selector in product page
          itemTotalQty = parseInt(amount) + itemCartQty;
        }
      });
    }

    // if the max money expendable is less than the amount of product selected in form multiplied by the selected variant price
    // OR
    // if the max money expendable is less than the sum of the selected quantity in the form in product page and the selected quantity of the same product in cart multiplied by the selected variant price
    if (more_av < amount * current_var_price || more_av < itemTotalQty * current_var_price) {
      // throw message of reached max amount in cart for the selected product

      // ------- END AF30042021 - Fix for check cart products quantity for product page -------
      alert(window.languages.reachedMaxAvailable);
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  });
});

function checkQtys() {
  $('.cart_item').each(function () {
    var itm = $(this);
    var data = itm.data();
    if (data.length > 0) {
      var parentId = data.product_parent_id;
      var price = data.line_price;
      var mymax = data.max_avaible;
      var line_var_id = data.line_var_id;
      var qty = (data.line_qty === undefined) ? 0 : data.line_qty;
      if (mymax != '') {
        var global_max = 0;
        var max_avaible = 0;
        var other_amount = $('.cart_item[data-product_parent_id=' + parentId + ']').map(function () {
          return $(this).data('line_price') * $(this).data('line_qty');
        }).get();
        console.log(other_amount);
        for (var i = 0; i < other_amount.length; i++) {
          global_max += parseFloat(other_amount[i]);
          console.log(global_max);
        }
        max_avaible = parseFloat(mymax - global_max);
        if (max_avaible > 0) {
          while ((price * qty) > (mymax + max_avaible)) {
            qty--;
          }
        } else {
          var exceed = Math.floor(max_avaible / price);
          qty = qty + exceed;
        }
        if (qty <= 0) {
          qty = 0;
        }
        itm.attr('data-line_qty', qty);
        itm.find('.price').text("€" + parseFloat(parseFloat(data.line_price) * parseInt(qty)).toFixed(2));
        itm.find('.quantity-selector__value').val(qty);
        $('.header__cart-count').text("" + qty);
        jQuery.ajax({
          type: 'POST',
          async: false,
          url: '/cart/change.js',
          data: { "id": line_var_id, "quantity": qty },
          dataType: 'json',
          success: function (dt) {
          }
        });
      }
    }
  });
}
